import React, { useContext } from "react";
import { 
  Card, 
  CardContent, 
  TextField, 
  Typography, 
  Grid,
  InputAdornment,
  Divider
} from "@mui/material";
import { 
  Phone as PhoneIcon, 
  Home as HomeIcon, 
  Email as EmailIcon, 
  LocationOn as LocationIcon,
  ContactMail as ContactIcon 
} from "@mui/icons-material";
import { Context } from "../../context";
import { MEDICAL_BILLING_PERSON } from "../../config";

const PatientInfoField = ({
  label,
  name,
  value,
  updatePatientInfo,
  painConsultNoteSigned,
  icon,
  placeholder,
  type = "text",
  multiline = false
}) => {
  const { user } = useContext(Context);
  
  return (
    <TextField
      variant="outlined"
      size="small"
      fullWidth
      margin="dense"
      label={label}
      value={value || ""}
      name={name}
      onChange={(e) => updatePatientInfo(e)}
      disabled={(user && user.role === MEDICAL_BILLING_PERSON)}
      placeholder={placeholder}
      type={type}
      multiline={multiline}
      rows={multiline ? 2 : 1}
      InputProps={{
        startAdornment: icon ? (
          <InputAdornment position="start">
            {icon}
          </InputAdornment>
        ) : null
      }}
    />
  );
};

const ContactInfo = ({
  contactInfo,
  setContactInfo,
  painConsultNoteSigned,
}) => {
  const updateContactInfo = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setContactInfo((values) => ({ ...values, [name]: value }));
  };

  return (
    <Card elevation={2} sx={{ height: '100%' }}>
      <CardContent>
        <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
          <ContactIcon sx={{ mr: 1 }} /> 
          Contact Information
        </Typography>
        
        <Divider sx={{ mb: 2 }} />
        
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <PatientInfoField
              label="Preferred Contact"
              name="preferred_contact"
              value={contactInfo.preferred_contact}
              updatePatientInfo={updateContactInfo}
              painConsultNoteSigned={painConsultNoteSigned}
              placeholder="Preferred method of contact"
            />
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <PatientInfoField
              label="Contact Number"
              name="contact_number"
              value={contactInfo.contact_number}
              updatePatientInfo={updateContactInfo}
              painConsultNoteSigned={painConsultNoteSigned}
              icon={<PhoneIcon color="primary" fontSize="small" />}
              placeholder="(555) 123-4567"
              type="tel"
            />
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <PatientInfoField
              label="Home Phone"
              name="home_phone"
              value={contactInfo.home_phone}
              updatePatientInfo={updateContactInfo}
              painConsultNoteSigned={painConsultNoteSigned}
              icon={<HomeIcon color="primary" fontSize="small" />}
              placeholder="(555) 123-4567"
              type="tel"
            />
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <PatientInfoField
              label="Email Address"
              name="email_address"
              value={contactInfo.email_address}
              updatePatientInfo={updateContactInfo}
              painConsultNoteSigned={painConsultNoteSigned}
              icon={<EmailIcon color="primary" fontSize="small" />}
              placeholder="patient@example.com"
              type="email"
            />
          </Grid>
          
          <Grid item xs={12}>
            <PatientInfoField
              label="Primary Address"
              name="primary_address"
              value={contactInfo.primary_address}
              updatePatientInfo={updateContactInfo}
              painConsultNoteSigned={painConsultNoteSigned}
              icon={<LocationIcon color="primary" fontSize="small" />}
              placeholder="123 Main St, City, State ZIP"
              multiline={true}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ContactInfo;